import { useLocation } from 'react-router-dom'

import { GetDatoModulesDocument, GetDatoModulesQueryVariables } from 'generated/resources/graphql'

import { useQuery } from 'modules/core/hooks/useQuery'

export const useGetDatoModules = (variables: GetDatoModulesQueryVariables) => {
  const { search } = useLocation()
  const preview = new URLSearchParams(search).get('preview') === 'true'
  const { loading, data, error } = useQuery(GetDatoModulesDocument, {
    variables: { ...variables, preview },
  })
  return {
    loading,
    data: data?.modules.datoModulesConnection.nodes || [],
    error,
  }
}
